import React, { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { useHistory } from "react-router-dom";
import { toTitleCase } from "../util/titleCase";

const NewHomework = ({ arrayDataSets }) => {
  // console.log(arrayDataSets, "arrayDataSetsarrayDataSetsarrayDataSets");
  const dataContext = useContext(DataContext);
  const history = useHistory();

  const sendClicked = (subject) => {
    // console.log(subject, "subjectsubjectsubjectsubject");
    localStorage.setItem("clickedHomework", JSON.stringify(subject));
    dataContext.setHomework(subject);
    history.push("/viewHomework");
  };
  

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-6 px-4 mb-16">
        {arrayDataSets && arrayDataSets.length === 0 ? (
          <div className="text-red-100 text-sm">
            {" "}
            Oops! No homework in this category{" "}
          </div>
        ) : (
         (arrayDataSets || []).map((item, index) => {
            const returnDueDate = item?.duedate;
            var userDateParts = returnDueDate?.split("/");
            var userYear = parseInt(userDateParts[2], 10);
            var userMonth = parseInt(userDateParts[1], 10) - 1; // Months are 0-indexed
            var userDay = parseInt(userDateParts[0], 10);

            var userSpecifiedDate = new Date(userYear, userMonth, userDay);

            // Get today's date
            var today = new Date();
            return (
              <div
                className="newHomework bg-white p-4 mb-6 text-gray-100 mr-4 newNotesShadow"
                key={index}
              >
                <div className="flex justify-between items-center mb-4">
                  <span className="text-gray-300 text-xs leading-4">
                    {" "}
                    {item.class}{" "}
                  </span>
                  {userSpecifiedDate < today ? (
                    <span className="w-3 h-3 bg-red-100 rounded-full" />
                  ) : (
                    <span className="w-3 h-3 bg-green-100 rounded-full" />
                  )}
                </div>
                <div className="block mx-auto newHomeworkPositioning">
                  {/* <div className="flex flex-col justify-center items-center mt-8"> */}
                  <div className="flex text-center justify-center mx-auto font-semibold hmwrkPos text-base mb-4">
                    {toTitleCase(item.subject)}
                  </div>

                  <div className="flex flex-col justify-center newHomeworkDate text-xs text-gray-500 px-2 leading-3 mb-4">
                    <span className="flex justify-center"> {item.date} </span>

                    {/* <span className="flex justify-center"> {item.time} </span> */}
                  </div>
                  <div className="bg-blue-900 block mx-auto newHomeworkView">
                    {/* <div className="bg-blue-900  "> */}
                    <span
                      onClick={() => {
                        sendClicked(item);
                      }}
                      className="flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer"
                    >
                      View Homework
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default NewHomework;
